import { render, staticRenderFns } from "./DeliveryExpense.vue?vue&type=template&id=0a9baf8c&lang=pug&"
import script from "./DeliveryExpense.vue?vue&type=script&lang=ts&"
export * from "./DeliveryExpense.vue?vue&type=script&lang=ts&"
import style0 from "./DeliveryExpense.vue?vue&type=style&index=0&id=0a9baf8c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports